import React, { Component } from "react";
import "./ReviewCard.css";
import { withFirebase } from "../Firebase";
import { withRouter } from "react-router-dom";
import Rater from 'react-rater'
import DefaultProfileImg from '../../components/assets/icon_user_profile.svg';

class ReviewCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  myStars = (card) => {
    return (
      <div className="d-flex flex-rate mb-3">
        <div className="stars-size">
          <Rater rating={card.rate} total={5} interactive={false} />
        </div>
        <span className="rating-span">{card.rate}/5</span>
      </div>
    )
  }

  callBackRatingList = () => {
    let capsule;
    if (!this.props.capsule) {
      return
    } else {
      capsule = this.props.capsule;
    }
    if (!capsule.ratingList) {
      return
    }
    return (
      <div className="d-flex scroll-list">
        {capsule.ratingList.filter(rating => rating.commentaire).map(card => (
          <div key={card.user} className="card-callback-container p-3">
            <div className="d-flex mb-1 header-callback-card">
              {card.image ? <img alt="profile" className="img-callback mr-2" src={card.image} /> :
                <img alt="profile" className="img-callback mr-2" src={DefaultProfileImg} />}
              <div>
                <span className="name-callback-card">{card.username}</span>
                <h1 className="position-user-card" hidden={!card.position}>{card.position}</h1>
              </div>
            </div>
            {this.myStars(card)}
            <div className="d-flex justify-content-center">
              <div className="box-input-card p-1">
                <p className="comment-size">{card.commentaire}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  render() {
    return (
      <>
        {this.callBackRatingList()}
      </>
    );
  }
}


const ReviewCardConnected = withRouter(withFirebase(ReviewCard));

export { ReviewCardConnected as ReviewCard }